<template>
    <ion-item>
        <ion-label class="ion-text-wrap">
            <h2>Create Box
                <ion-text v-if="create" color="success">On</ion-text>
                <ion-text v-else color="danger">Off</ion-text>
            </h2>
            <p class="ion-text-justify">
                Create a new box and put this line in it?
            </p>
        </ion-label>
        <ion-toggle slot="end" :value="true" @ionChange="create = $event.target.checked" :checked="create" />
    </ion-item>
</template>

<script>
import {IonItem, IonLabel, IonToggle,IonText} from '@ionic/vue';
import {computed} from 'vue';

export default {
    name: "NewBoxToggle",
    emits: ['update:modelValue'],
    props: ['modelValue'],
    components: {
        IonItem,
        IonText,
        IonToggle,
        IonLabel
    },
    setup(props, {emit}) {
        // Explanation of how to get v-model working in Vue 3:
        // https://www.vuemastery.com/blog/vue-3-data-down-events-up/
        const create = computed({
            get: () => props.modelValue,
            set: (value) => {
                emit('update:modelValue', value);
            }
        });
        return {create};
    }
}
</script>

<style scoped>

</style>
